import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { timeslotsServices } from 'api/services';
import Template from 'components/Template/Template';
import { Button, Grid, TextField, Typography } from '@mui/material';
import { ShowNotification } from 'helpers/showNotice';
import { NoticeStatus } from 'store/ducks/notice/types';
import { MainLoader } from 'components/Loader/Loader';
import { AppState } from 'store/store';
import { useSelector } from 'react-redux';
import { ITimeslot } from 'api/services/timeslots/types';
import './CreateTimeslotPage.sass';

export const CreateTimeslotPage: React.FC = () => {
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fromTime, setFromTime] = useState('');
  const [toTime, setToTime] = useState('');
  const history = useNavigate();
  const i18n = useSelector(
    (state: AppState) => state.i18n.data.pages.timeslotsPage
  );

  const createTimeslot = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!fromTime.trim() || !toTime.trim()) {
      setHasError(true);
      setLoading(false);
      ShowNotification('Заполните поля');
      return;
    }
    const timeslot: ITimeslot = {
      fromTime,
      toTime,
    };

    try {
      setLoading(true);
      await timeslotsServices.createTimeslot(timeslot);
      ShowNotification(i18n.createdTimeslot, NoticeStatus.SUCCESS);
      history(`/timeslots`);
    } catch (e: any) {
      ShowNotification(e.response?.data?.message || 'Ошибка сервера');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Template>
      <div className='create-timeslot-page'>
        <Typography variant='h3'>{i18n.createTimeslot}</Typography>
        <form
          className='create-timeslot-page__form'
          onSubmit={createTimeslot}
          style={{ marginTop: 20 }}
        >
          <Grid
            className='row'
            container
            item
            md={6}
            spacing={2}
            alignItems='flex-end'
          >
            <Grid item xs={6}>
              <TextField
                value={fromTime}
                onChange={(e) => setFromTime(e.target.value)}
                label={i18n.fromTime}
                autoComplete='off'
                variant='outlined'
                size='small'
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  step: 60,
                }}
                type='time'
                error={hasError && !fromTime.trim()}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={toTime}
                onChange={(e) => setToTime(e.target.value)}
                label={i18n.toTime}
                autoComplete='off'
                variant='outlined'
                size='small'
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  step: 60,
                }}
                type='time'
                error={hasError && !toTime.trim()}
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            md={6}
            spacing={2}
            className='create-timeslot-page__button-wrap'
            justifyContent='flex-end'
            style={{ marginTop: 20 }}
          >
            <Grid item xs={3}>
              <Link className='create-timeslot-page__button' to={`/timeslots`}>
                <Button
                  variant='contained'
                  color='inherit'
                  className='create-timeslot-page__button'
                  size='large'
                  fullWidth
                >
                  {i18n.back}
                </Button>
              </Link>
            </Grid>
            <Grid item xs={3}>
              <Button
                variant='contained'
                color='success'
                className='create-timeslot-page__button'
                type='submit'
                disabled={loading}
                size='large'
              >
                {loading ? <MainLoader /> : `${i18n.save}`}
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </Template>
  );
};
